// The login's access token for our own /api/ calls, refreshed when it is about to run out. After a few hours with the tab
// asleep the stored token can be expired (the refresh timer did not run) - the AI then said "Invalid or expired session".
// authFetch.js uses it for every /api/ call and, on a 401, refreshes once and sends the call again.
export const REFRESH_MARGIN_S = 120   // refresh when less than 2 minutes are left

// sb: the Supabase client; force: refresh even if the token still looks valid (the server said 401)
export async function freshToken(sb, { force = false, now = Date.now() } = {}) {
  const { data } = await sb.auth.getSession()
  const s = data && data.session
  if (!s) return null
  const left = (Number(s.expires_at) || 0) - Math.floor(now / 1000)
  if (!force && left > REFRESH_MARGIN_S) return s.access_token
  try {
    const r = await sb.auth.refreshSession()
    const ns = r && r.data && r.data.session
    if (ns && ns.access_token) return ns.access_token
  } catch (e) {}
  return force ? null : s.access_token   // offline / refresh refused: the old one (the server decides)
}

// fetch with the login's token: fresh before the call, refreshed + sent again once on a 401. Bodies that cannot be sent twice
// (a stream) are not retried.
export async function fetchWithLogin(doFetch, sb, input, init = {}, { setHeader = true } = {}) {
  const h = new Headers(init.headers || (typeof input !== 'string' && input && input.headers) || undefined)
  const own = setHeader && !h.has('Authorization')
  let sent = null
  if (own) { sent = await freshToken(sb).catch(() => null); if (sent) h.set('Authorization', 'Bearer ' + sent) }
  const first = await doFetch(input, own && sent ? { ...init, headers: h } : init)
  if (first.status !== 401) return first
  const body = init && init.body
  if (body && typeof body !== 'string' && !(typeof FormData !== 'undefined' && body instanceof FormData) && !(typeof Blob !== 'undefined' && body instanceof Blob)) return first
  const t = await freshToken(sb, { force: true }).catch(() => null)
  if (!t) return first
  h.set('Authorization', 'Bearer ' + t)
  return doFetch(input, { ...init, headers: h })
}
